import React from "react";
import ReactDOM from "react-dom";
//import axios from "axios";

import { MainRoutes } from "./routes";

import "./index.css";

// const axiosClient = axios.create({
//   baseURL: "https://api.apps.pdview.com.au/" //"http://localhost:5000/"
// });
// window.axiosClient = axiosClient;

ReactDOM.render(<MainRoutes />, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js